module.exports = __webpack_public_path__ + "img/1.95086db1.jpg";